// extracted by mini-css-extract-plugin
module.exports = {"root":"TimetableSplitViewEventListItem_root_3uj9l","activeItem":"TimetableSplitViewEventListItem_activeItem_3KT1X"};